import { useQuery } from "@apollo/client";
import { EventsByUserOrganizationIdDocument } from "../../../../../../__generated__/graphql";

export default function useEventsByUserOrganizationId(
  userOrganizationId?: string | null
) {
  const { data, loading, error, refetch } = useQuery(
    EventsByUserOrganizationIdDocument,
    {
      variables: {
        userOrganizationId: userOrganizationId ?? "",
      },
      skip: !userOrganizationId,
    }
  );

  return { data, loading, error, refetch };
}
